import React from 'react'
import Logo from '../assets/logo.png'
import { Link } from 'react-router-dom';
// import Box from '@mui/material/Box';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import Drawer from '@mui/material/Drawer';
// import Button from '@mui/material/Button';
// import { RxHamburgerMenu } from "react-icons/rx";

function Header() {
  // const [open, setOpen] = React.useState(false);

  // const toggleDrawer = (newOpen) => () => {
  //   setOpen(newOpen);
  // };

  // const DrawerList = (
  //   <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)} className='bg-black min-h-screen pt-20 flex flex-col'>
  //     <List>
  //       <ListItem >
  //         <ListItemButton>
  //           <a href="/" className='text-gradient btn-link'>Home</a>
  //         </ListItemButton>
  //       </ListItem>
  //       <ListItem >
  //         <ListItemButton>
  //           <a href="/github" className='text-gradient btn-link'>Github</a>
  //         </ListItemButton>
  //       </ListItem>
  //       <ListItem >
  //         <ListItemButton>
  //           <a href="/spotify" className='text-gradient btn-link'>Spotify</a>
  //         </ListItemButton>
  //       </ListItem>
  //       <ListItem className='mt-10' >
  //         <ListItemButton>
  //           <a className="btn btn-sm flex justify-center items-center" href="mailto:jasdevbedi.aus@gmail.com">Work With Me</a>
  //         </ListItemButton>
  //       </ListItem>
  //     </List>

  //   </Box>
  // );

  return (
    <div className='py-4 lg:py-8 md:min-h-[60px]'>
      <div className="container mx-auto">
        <div className='flex justify-between items-center'>
          <Link to="/">
            <img src={Logo} alt="Jasdev Bedi's Portfolio" className="logo hidden lg:block" />
          </Link>
          <div className='ml-auto  items-center gap-10 hidden lg:flex'>
            {/* <a href="/" className='text-gradient btn-link ml-4'>Home</a>
            <a href="/github" className='text-gradient btn-link ml-4'>Github</a>
            <a href="/spotify" className='text-gradient btn-link ml-4'>Spotify</a> */}
            <a className="btn btn-sm flex justify-center items-center" href="mailto:jasdevbedi.aus@gmail.com">Work With Me</a>
          </div>
          {/* <div className='block lg:hidden'>
            <Button onClick={toggleDrawer(true)} ><RxHamburgerMenu className='text-accent text-2xl' /></Button>
            <Drawer open={open} onClose={toggleDrawer(false)} anchor='right' className='bg-black/15'>
              {DrawerList}
            </Drawer>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default Header
